import {useState, useEffect} from 'react'
import {Aff_question} from "./Aff_question"
import {niveaux, users_fictifs} from "../config/Config"

export function Admin ({auth}) {

	const [quest, setQuest] = useState({
		niv:'3e',
		num:'1',
		question:['', '', '', '', '']
	})


	const handleChange = (e) => {
  		let niv = e.target.value.replace('_p', 'p').split('_')[0]
		const num = e.target.value.replace('_p', 'p').split('_')[1]
		niveaux.forEach(e =>{
  			if (niv === e.slug.replace('maths', '').replace('-', '').replace('_pro', 'p').replace('spe', '').slice(0,5)) {niv = e.slug}
	  	})
		setQuest({...quest, niv, num})

	}

	const handleSubmit = (e) => {
  	fetch("https://maths-au-quotidien.fr/react-automaths/api-questions.php", {
	      method: 'POST',
	      body: JSON.stringify({...auth, action:'admin_question', niveau:quest.niv, num:quest.num})
	    })
	    .then(response => response.json())
	    .then(data => {
	    	//console.log('data Modal : ', data)
	      	setQuest({...quest, question:data})
	    })
	    .catch(err => console.log(err))
  	}

  	let menu_admin = ['Général', 'Connexions', 'En travaux', '6 messages']
  	menu_admin = menu_admin.map((e, k) => <li key={k} className={'onglet' + (k === 0 ? ' active' : '')}>{e}</li>)

  	// ========= TEST ==========
  	const users = []
  	const users_affiche = users_fictifs.map((e,k)=>{
  		let user_classe =''
  		if (e.profil === 'Professeur') {user_classe ='chocolate'}
  		if (e.profil === 'Autre') {user_classe ='green'}
  		return <span key={k}>
	  			<span className={user_classe} title={e.classe}>{e.prenom}  {e.nom} (02/03)</span>
	  			<br/>
  			</span>
  		})
  	// =========================

  	//console.log(quest.question[3])
	return (
		auth.statut?.includes('admin_314') && <>
		<ul className="onglet">
			{menu_admin}
		</ul>
		<ul className="onglet_content">
			<li>
			<h1>Tableau de bord</h1>
				<div className="content">
					<h1>Dernières connexions</h1>
					<div style={{columns:2}} >
						{users_affiche}
					</div>
				</div> 
				<div className="content" style={{textAlign:'left'}} >
					<h1>Quelques statistiques </h1>
					7684 comptes créés <br/>
					114 professeurs ont créé des devoirs <br/>
					748 devoirs sont actuellement envoyés aux élèves <br/>
					55 professeurs ont activé la différenciation <br/>
					620 comptes professeur ont été créés <br/>
					6562 comptes élève ont été créés par des professeurs <br/>
					456 comptes Elèves « Autres » ont été créés <br/>
					46 comptes Autres ont été créés <br/>
					65 devoir différenciés <br/>
					3 classes partagées

					<h1>Dernier message </h1>
					<div className="messages">
					<div className="message" style={{width:'80%'}} >
						<div className="suppr">
						</div>
						<div className="info_mess">
							houdaferhaoui05@gmail.com <br/> 21/02/2024						</div>
						<h1>Monopoly</h1>
						Madame, Monsieur,<br/>
						je suis élève du deuxième année en classes préparatoires filière MP. J'ai choisi la modélisation de Monopoly pour mon sujet TIPE. 
						J'ai trouvé des ressources pour le calcul des probabilités en Monopoly mais je n'arrive pas à comprendre comment on a obtenu probabilités en la matrice de transition, même après jouer votre jeu. Veillez m'envoyer les documents ressources ou la méthode des réponses pour pouvoir comprendre les calculs.<br/>
						Grand merci<br/>
					</div>
				</div>
				</div>
				
			</li>
		</ul>
		{
			<div>
				Entrer la référence de la question : <input type="text" onChange={handleChange} /> 
				<input type="button" value="Envoyer" onClick={handleSubmit} />
			</div>
		}
		{
			quest.question[0] && 
				<>
				<Aff_question question={quest.question}/>
				<br/><br/>
				Réponse(s) attendue(s) : {quest.question[4] ? (quest.question[4]+'').replaceAll('__', ' ou ') : quest.question[3][0]}
				</>
		}
		</>
	);
}